import React, { useEffect } from "react";
import { Input, Form } from "antd";

import "./index.less";
import { GST18, GST28, GST12, GST5 } from "../../../../../utils";
const GSTTable = (props) => {
  let supgst = 0;
  let branchgst = 0;
  const {
    SGST,
    CGST,
    IGST,
    itemList,
    GSTRate18,
    GSTRate28,
    GSTRate12,
    GSTRate5,
    stateName,
    gst,
  } = props;
  useEffect(() => {
    if (gst && stateName) {
      supgst = stateName.slice(0, 2);
      branchgst = gst.slice(0, 2);
    }
  }, [gst, stateName]);
  const renderGSTData = (itemList, gstValue, label) => {
    let totalCGST = 0;
    let totalSGST = 0;
    let totalIGST = 0;
    for (let item of itemList) {
      if (Number(item.gstRate) === gstValue * 2) {
        totalCGST += parseFloat(item.cgstAmount || 0);
        totalSGST += parseFloat(item.sgstAmount || 0);
        totalIGST += parseFloat(item.igstAmount || 0);
      }
    }
    totalCGST = totalCGST.toFixed(2);
    totalSGST = totalSGST.toFixed(2);
    totalIGST = totalIGST.toFixed(2);
    return (
      <div className="gst-row-group" key={label}>
        {/* <div className="gst-row-label">
          <b>
            {label} (IGST {gstValue * 2}%)
          </b>
        </div> */}
        <Form.Item
          className="form-element"
          label={`CGST ${gstValue}%`}
          name={`cgst_${gstValue}`}
        >
          <Input disabled={true} value={totalCGST} style={{ marginLeft: 20 }} />
        </Form.Item>
        <Form.Item
          className="form-element"
          label={`SGST ${gstValue}%`}
          name={`sgst_${gstValue}`}
        >
          <Input disabled={true} value={totalSGST} style={{ marginLeft: 20 }} />
        </Form.Item>
        {/* <Form.Item
          className="form-element"
          label={`IGST (${gstValue * 2}%)`}
          name={`igst_${gstValue}`}
        >
          <Input disabled={true} value={totalIGST} />
        </Form.Item> */}
      </div>
    );
  };

  const uniqueGstRates = Array.from(
    new Set(
      (itemList || [])
        .map((item) => Number(item.gstRate))
        .filter((rate) => rate > 0 && !isNaN(rate))
    )
  ).sort((a, b) => b - a);

  return (
    <>
      {uniqueGstRates.map((gstRate) =>
        renderGSTData(itemList || [], gstRate / 2, `GST ${gstRate}%`)
      )}
    </>
  );
};

export default GSTTable;
